/* eslint-disable */
import React, { useEffect, forwardRef, useRef, useImperativeHandle, useState } from 'react';

import './_date-picker.scss'
import './_date-picker.dark-mode.scss'

import $ from 'jquery';
import { FormControl } from 'react-bootstrap';
import { random } from 'lodash';

import { formatDate } from '../../../utils/helper';
import { UI_NAME } from '../../../utils/config';


const DatePicker = forwardRef(({ value, minDate, maxDate, onChange }, ref) => {
  const inputRef = useRef(null);
  const instanceRef = useRef(null);
  const [inputValue, setInputValue] = useState(formatDate(value)); // Локальное состояние для ввода
  const id = random(0, 999999);

  useEffect(() => {
    setInputValue(formatDate(value));
  }, [value]);

  useEffect(() => {

    instanceRef.current = $(inputRef.current).datetimepicker({
      format: 'YYYY-MM-DD',
      minDate: minDate ? new Date(minDate) : 0,
      maxDate: maxDate ? new Date(maxDate) : null,
      defaultDate: value ? new Date(value) : null,
    });

    const handlePickerChange = (e) => {
      const newDate = e.date ? formatDate(e.date) : '';
      setInputValue(newDate);
      onChange(newDate);
    };

    const handlePickerHide = (e) => {
      const currentDate = instanceRef.current.data('DateTimePicker').date();
      const picker = instanceRef.current.data('DateTimePicker');
      const currentMinDate = picker.minDate();

      const newDate = currentDate ? formatDate(currentDate) : '';
      const formatMinDate = currentMinDate ? formatDate(currentMinDate) : minDate;

      if (newDate !== inputValue) {
        setInputValue(newDate);
        onChange(newDate);
      } else {
        onChange(newDate ? newDate : formatMinDate);
      }
    };

    $(inputRef.current).on('dp.change', handlePickerChange);
    $(inputRef.current).on('dp.hide', handlePickerHide);

    return () => {
      $(inputRef.current).off('dp.change', handlePickerChange);
      $(inputRef.current).off('dp.hide', handlePickerHide);
      instanceRef.current.data('DateTimePicker').destroy();
    };
  }, []);

  useEffect(() => {
    if (instanceRef.current) {
      const picker = instanceRef.current.data('DateTimePicker');

      if (value) {
        picker.date(new Date(value));
      } else {
        picker.date(null);
      }

      const minDateObj = minDate ? new Date(minDate) : null;
      const maxDateObj = maxDate ? new Date(maxDate) : null;

      let adjustedMaxDate = maxDateObj;
      if (minDateObj && (maxDateObj === null || maxDateObj === undefined || minDateObj > maxDateObj)) {
        adjustedMaxDate = minDateObj;
      }

      picker.minDate(minDateObj || false);
      picker.maxDate(adjustedMaxDate ? adjustedMaxDate : false);
    }
  }, [minDate, maxDate]);

  const onBlur = (e) => {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

    if (dateRegex.test(inputValue)) {
      const date = new Date(inputValue);
      const today = new Date();

      today.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);

      if (date > today) {
        const formattedToday = formatDate(today);
        onChange(formattedToday);
        setInputValue(formattedToday);
        return;
      }

      if (!isNaN(date)) {
        onChange(formatDate(date));
        return;
      }
    }

    if (inputValue === '') {
      onChange('');
      setInputValue('');
    } else {
      const fallbackDate = value || formatDate(new Date());
      const formattedFallback = formatDate(fallbackDate);
      onChange(formattedFallback);
      setInputValue(formattedFallback);
    }
  };

  useImperativeHandle(ref, () => ({
    focus: () => inputRef.current.focus()
  }));

  return (
    <div className={`${UI_NAME}-datepicker`}>
      <label htmlFor={`datepicker-${id}`} className={`${UI_NAME}-datepicker__icon`}>
        <svg
          width="14"
          height="15"
          viewBox="0 0 14 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.875 13.4375V6H13.125V13.4375C13.125 14.1758 12.5234 14.75 11.8125 14.75H2.1875C1.44922 14.75 0.875 14.1758 0.875 13.4375ZM2.625 8.1875V10.8125C2.625 11.0586 2.81641 11.25 3.0625 11.25H5.6875C5.90625 11.25 6.125 11.0586 6.125 10.8125V8.1875C6.125 7.96875 5.90625 7.75 5.6875 7.75H3.0625C2.81641 7.75 2.625 7.96875 2.625 8.1875ZM11.8125 2.5C12.5234 2.5 13.125 3.10156 13.125 3.8125V5.125H0.875V3.8125C0.875 3.10156 1.44922 2.5 2.1875 2.5H3.5V1.1875C3.5 0.96875 3.69141 0.75 3.9375 0.75H4.8125C5.03125 0.75 5.25 0.96875 5.25 1.1875V2.5H8.75V1.1875C8.75 0.96875 8.94141 0.75 9.1875 0.75H10.0625C10.2812 0.75 10.5 0.96875 10.5 1.1875V2.5H11.8125Z"
            fill="currentColor" />
        </svg>
      </label>
      <FormControl
        id={`datepicker-${id}`}
        autoComplete="off"
        onChange={(e) => {
          const rawValue = e.target.value;
          const cleaned = rawValue.replace(/\D/g, '');
          const formatted = cleaned
            .replace(/^(\d{4})(\d)/, '$1-$2')
            .replace(/^(\d{4}-\d{2})(\d)/, '$1-$2')
            .substring(0, 10);
          setInputValue(formatted);
        }}
        onBlur={onBlur}
        value={inputValue}
        inputRef={(inputR) => {
          inputRef.current = inputR;
        }}
        type="text"
        maxLength={10}
        inputMode="numeric"
        pattern="[0-9]*"
      />
    </div>
  )
});

export default DatePicker;
